export enum AzureWebPubSubEvents {
  Connected = 'connected',
  Disconnected = 'disconnected',
  ServerMessage = 'server-message',
}

export enum EventTypes {
  Connect = 'connect',
  Heartbeat = 'heartbeat',
}

export enum AlertTypes {
  WatchMeActivate = 'WatchMeActivate',
}

export enum DatadogActions {
  ConnectionError = 'axon_azure_webpubsub_connection_error',
  UrlReceived = 'axon_azure_webpubsub_url_received',
  Connected = 'axon_azure_webpubsub_connected',
  Disconnected = 'axon_azure_webpubsub_disconnected',
  MessageReceived = 'axon_azure_webpubsub_message_received',
  ClientStarted = 'axon_azure_webpubsub_client_started',
  DuplicateClientStartAttempted = 'axon_azure_webpubsub_duplicate_client_start_attempted',
  TokenError = 'axon_azure_webpubsub_token_error',
  ConnectionRetry = 'axon_azure_webpubsub_connection_retry',
  ConnectionFailed = 'axon_azure_webpubsub_connection_failed',
  ConnectionRegistered = 'axon_azure_webpubsub_connection_registered',
  HeartbeatStarted = 'axon_azure_webpubsub_heartbeat_started',
  HeartbeatFailed = 'axon_azure_webpubsub_heartbeat_failed',
  HeartbeatSent = 'axon_azure_webpubsub_heartbeat_sent',
  HeartbeatError = 'axon_azure_webpubsub_heartbeat_error',
  HeartbeatStopped = 'axon_azure_webpubsub_heartbeat_stopped',
  AlertShownShadowMode = 'axon_azure_webpubsub_alert_shown_shadow_mode',
  AlertShownEnabledMode = 'axon_azure_webpubsub_alert_shown_enabled_mode',
}

export const API_ENDPOINTS = {
  CLIENT_REGISTRATIONS: '/alerts/delivery/in-app/register',
  CLIENT_CONNECTIONS: '/alerts/delivery/in-app/connect',
} as const;

export const CONNECTION_CONFIG = {
  HEARTBEAT_INTERVAL: 60000,
  MAX_RETRY_COUNT: 3,
  RETRY_BASE_DELAY_MS: 1000,
  RETRY_MAX_DELAY_MS: 30000,
} as const;

export const ERROR_MESSAGES = {
  NO_TOKEN: 'No Axon token available for Azure WebPubSub connection',
} as const;

export const AUDIO_FILES = {
  sound_critical: '/assets/notifications/alarm.wav',
  alert: '/assets/notifications/alarm.wav',
} as const;

export const ICONS = {
  body_cam_3: {
    fontSet: 'fs',
    fontIcon: 'ab3',
  },
  warning_icon: {
    fontSet: 'fa',
    fontIcon: 'fa-exclamation-triangle',
  },
  cad_diamond: {
    fontSet: 'fa',
    fontIcon: 'fa-diamond',
  },
} as const;

export type AxonAlertActionType = 'viewDetails' | 'viewLivestream' | 'viewOnMap' | 'dockNearby' | 'snooze';
export type AxonAlertStyleIcons = keyof typeof ICONS;
export type AxonAlertStyleColors = 'critical_red' | 'red';
export type AxonAlertSounds = keyof typeof AUDIO_FILES;

export const ALERT_STATUSES = {
  active: 'active',
  cancelled: 'cancelled',
} as const;


export const ALERT_NOTIFICATION_VERSION = {
  LEGACY_CX: 'legacy25',
  AXON_ALERTS: 'aa',
} as const;

export const ALERT_INTERACTION_ACTION = {
  CLICK: 'Click on Toast',
  DOCK_CAMERA: 'Dock Camera',
  DOCK_NEARBY_CAMERAS: 'Dock Nearby Cameras',
  FOLLOW_MODE: 'Follow Mode',
  SNOOZE: 'Snooze',
  VIEW_ON_MAP: 'View',
  SHOW_DIALOG: 'Show Dialog',
} as const;

export const DEVICE_ALERT_TYPES = {
  PANIC: 'com.axon.alert.panic',
  WATCH_ME: 'com.axon.alert.watchme',
} as const;